import { render, staticRenderFns } from "./HomeContentLayout.vue?vue&type=template&id=a1a72f64&scoped=true"
import script from "./HomeContentLayout.vue?vue&type=script&lang=js"
export * from "./HomeContentLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeContentLayout.vue?vue&type=style&index=0&id=a1a72f64&prod&scoped=true&lang=less"
import style1 from "./HomeContentLayout.vue?vue&type=style&index=1&id=a1a72f64&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a72f64",
  null
  
)

export default component.exports